export const AccomplishmentsBar = ({
	page,
	setPage
	}: {
		page: string
		setPage: (page: 'ACHIEVEMENTS' | 'RATING') => void
	}) => {
	return (
		<div className="research-tree-branch-bar">
			<img 
				className={`accomplishments-tree-branch-bar-item ${page === 'ACHIEVEMENTS' ? 'active' : ''}`} 
				src="/icons/64px/medal.webp" 
				alt="Germany"
				onClick={() => setPage('ACHIEVEMENTS')}
			/>
			<img 
				className={`accomplishments-tree-branch-bar-item ${page === 'RATING' ? 'active' : ''}`} 
				src="/icons/64px/prize.webp" 
				alt="Japan" 
				onClick={() => setPage('RATING')}
			/>
		</div>
	)
}